import { api } from '../config/api'
import { AREAS } from './actionTypes'

export const getArea = () => (dispatch, getState) => {
  const { lang } = getState()
  if (!getState().areas.length) {
    dispatch({ type: AREAS.REQUEST })
    return (
      fetch(api.areas)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: AREAS.SUCCESS, data: res })
      })
      .catch((err) => {
        dispatch({ type: AREAS.FAILURE, error: err })
      })
    )
  }
}


// WEBPACK FOOTER //
// ./src/actions/getArea.js